import {
  createRef,
  Suspense,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { DoubleSide, Euler, Mesh, TextureLoader } from "three";
import { DataType, Floor, Point } from "./Data";
import img from "../../../assets/images/map.jpeg";
import { CanvasLaoder } from "./CanvasLaoder";
import { useCommanData } from "../../../contexts/commanData.context";
import { Get, handleError } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import leftClick from "../../../assets/icons/left-click.svg";
import rightClick from "../../../assets/icons/right-click.svg";
import zoom from "../../../assets/icons/mouse-scroll-wheel.svg";
import {
  IoIosAddCircle,
  IoIosAddCircleOutline,
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosSearch,
} from "react-icons/io";
import { LuLayers } from "react-icons/lu";
import { IoClose, IoCloseSharp, IoDocumentTextOutline } from "react-icons/io5";
import Image from "../../../components/Image/Image.component";
import { FloorComponent } from "./Floor";
import NoData from "../../../components/noData/noData.component";
import { toast } from "react-toastify";
import "./three-d.css";

export default function ThreeD({ opacity }: any) {
  // const zDimaintion = 0.001;
  const { t } = useTranslation();
  const { segments, sectors, setSectors, API_LINK } = useCommanData();
  const { getValidToken, userData, isUser, socket } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [colorFilter, setColorFilter] = useState<string>("");
  const [brokenFloorImages, setBrokenFloorImages] = useState<string[]>([]);
  const [resetFloor, setResetFloor] = useState<boolean>(false);
  const [resetLayout, setResetLayout] = useState<boolean>(true);
  const [floorAnimation, setFloorAnimation] = useState<string>("");
  const [cursol, setCursol] = useState<string[]>([]);
  const [active, setActive] = useState<boolean>(false);
  const [activeFloor, setActiveFloor] = useState<number>(0);
  const [hoveredMesh, setHoveredMesh] = useState<string>("");
  const [targetPin, setTargetPin] = useState<string>("");
  const [targetPointReport, setTargetPointReport] = useState<any>(null);
  const [, setTargetPointReportAnswers] = useState<any>(null);
  const [selectedPoint, setSelectedPoint] = useState<any>(null);
  const [searchActive, setSearchActive] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [siteLayout, setSiteLayout] = useState<DataType>([]);
  const [floorImages, setFloorImages] = useState([]);
  const [toggleInstructions, setToggleInstructions] = useState<boolean>(false);
  const [pointReports, setPointReports] = useState<any>([]);
  const [, setSelectedReport] = useState<number>(0);
  const services =
    userData[0]?.asdc_client_contract?.client_service_relationship?.map(
      (service: any) => {
        return {
          name: service?.asdc_client_service?.asdc_client_service_name,
          id: service?.asdc_client_service_id,
        };
      }
    ) || [];
  const [selectedService, setSelectedService] = useState<number | null>(
    services?.length === 1 ? services[0]?.id : null
  );

  // const [selectedServiceName, setSelectedServiceName] = useState<string>(
  //   userData[0]?.asdc_client_contract?.client_service_relationship[0]
  //     ?.asdc_client_service?.asdc_client_service_name
  // );
  const defaltDate = {
    startDate: "",
    endDate: "",
  };
  const formatDateToISO = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = ("0" + (now.getMonth() + 1)).slice(-2);
    const day = ("0" + now.getDate()).slice(-2);
    const hours = ("0" + now.getHours()).slice(-2);
    const minutes = ("0" + now.getMinutes()).slice(-2);
    const formattedDate =
      year + "-" + month + "-" + day + "T" + hours + ":" + minutes;
    return formattedDate;
  };
  const [date, setDate] = useState<any>(defaltDate);
  const [filter, setFilter] = useState<any>({
    selects: true,
    dates: false,
  });

  //   const todayDate =
  //   new Date().getFullYear() +
  //   "-" +
  //   String(new Date().getMonth() + 1).padStart(2, "0") +
  //   "-" +
  //   String(new Date().getDate()).padStart(2, "0");

  const mapLoader = useLoader(
    TextureLoader,
    floorImages.filter(Boolean).map((img) => `${API_LINK}${img}`) || img
  );

  const colors: string[][] = siteLayout.map((floor) =>
    floor.points.map((p) => p.color)
  );
  const color1 = colors.map((f) => f.filter((c) => c === "green"));
  const color2 = colors.map((f) => f.filter((c) => c === "orange"));
  const color3 = colors.map((f) => f.filter((c) => c === "red"));
  const color4 = colors.map((f) =>
    f.filter((c) => c !== "green" && c !== "red" && c !== "orange")
  );

  const targetFloor = () => {
    if (activeFloor) {
      return {
        ...siteLayout[activeFloor],
        points: siteLayout[activeFloor].points.filter(
          (point) => point.color === colorFilter || colorFilter === ""
        ),
      };
    } else {
      return {
        ...siteLayout[0],
        points: siteLayout[0].points.filter(
          (point) => point.color === colorFilter || colorFilter === ""
        ),
      };
    }
  };

  const inspectionPointsCount: number | undefined =
    userData?.[0]?.asdc_client_contract?.inspection_points_count;

  const sites =
    userData[0]?.user_sites_relationShip?.map((site: any) => site?.site) || [];

  const filterdSectors =
    sectors.filter((sector: any) => {
      return (
        userData[0]?.user_sites_relationShip?.filter(
          (site: any) =>
            site.site.asdc_client_sector_id === sector.asdc_client_sector_id
        ).length > 0 && sector
      );
    }) || [];

  const filterdSegments =
    segments.filter((segment: any) => {
      return (
        filterdSectors
          .map((sector: any) => sector.segment_id)
          .includes(segment.id) && segment
      );
    }) || [];

  const defaultSiteId = sites.length === 1 ? sites[0]?.site_id : 0;

  const defaultSectorId =
    defaultSiteId > 0
      ? sites.find((site: any) => site.site_id === defaultSiteId)
          ?.asdc_client_sector_id
      : filterdSectors?.length === 1
        ? filterdSectors[0]?.asdc_client_sector_id
        : 0;

  const defaultSegmentId =
    defaultSectorId > 0
      ? filterdSectors.find(
          (sector: any) => sector.asdc_client_sector_id === defaultSectorId
        )?.segment_id
      : filterdSegments?.length === 1
        ? filterdSegments[0]?.id
        : 0;

  const [siteId, setSiteId] = useState<number>(defaultSiteId);
  const [sectorId, setSectorId] = useState<number>(defaultSectorId);
  const [segmentId, setSegmentId] = useState<number>(defaultSegmentId);

  const elementsRef = useRef<any>(
    siteLayout?.map(() => createRef<any>()) || []
  );
  const controlsRef = useRef<any>(null);
  const cameraRef = useRef<any>(null);

  const [initialPositions, setInitialPositions] = useState<
    [number, number, number][]
  >([]);

  // const initialPositions: Array<[number, number, number]> = [
  //   [0, -5.5, 0],
  //   [0, -5, 0],
  //   [0, -4.5, 0],
  //   [0, -4, 0],
  //   [0, -3.5, 0],
  //   [0, -3, 0],
  //   [0, -2.5, 0],
  //   [0, -2, 0],
  //   [0, -1.5, 0],
  //   [0, -1, 0],
  //   [0, -0.5, 0],
  //   [0, 0, 0],
  // ];

  const initialRotation: [number, number, number] = [4.7, 0, 0.8];
  const initArgs: [number, number, number] = [3, 3, 1];

  // const sitesOptions =
  //   sectors?.map((sector: any) => ({
  //     isDisabled: false,
  //     label: sector?.asdc_client_sector_name || "",
  //     options: sites
  //       ?.filter(
  //         (site: any) =>
  //           site?.asdc_client_sector_id === sector?.asdc_client_sector_id
  //       )
  //       .sort((a: any, b: any) => a.site_id - b.site_id)
  //       .map((site: any) => ({
  //         isDisabled: false,
  //         value: site?.site_id || "",
  //         label: site?.site_name || "",
  //       })),
  //   })) || [];
  // const formatGroupLabel = (data: any) => (
  //   <div className="flex justify-between items-center">
  //     <span>{data.label}</span>
  //     <span className="bg-[#EBECF0] text-[#172B4D] rounded-full px-2 py-1 text-xs font-normal">
  //       {data.options.length}
  //     </span>
  //   </div>
  // );

  const sitesOptions =
    sites
      ?.filter((site: any) => site?.asdc_client_sector_id === sectorId)
      .map((site: any) => ({
        isDisabled: false,
        value: site?.site_id || "",
        label: site?.site_name || "",
      })) || [];

  const sectorsOptions =
    filterdSectors
      ?.filter((s: any) => (segmentId > 0 ? s.segment_id === segmentId : true))
      ?.map((sector: any) => ({
        value: sector?.asdc_client_sector_id,
        label: sector?.asdc_client_sector_name,
      })) || [];

  const segmentsOptions =
    filterdSegments?.map((segment: any) => ({
      value: segment?.id,
      label: segment?.name,
    })) || [];

  const servicesOptions =
    userData[0]?.userServices?.map((service: any) => {
      return {
        value: service?.asdc_client_service_id,
        label: service?.asdc_client_service_name,
      };
    }) || [];

  // console.log(userData, servicesOptions);
  // console.log(sites.find((site: any) => site.site_id === siteId))

  // console.log(targetPointReport);

  const convertReport = (data: any) => {
    const answersByFormId: Record<string, Array<any>> = {};
    // console.log(data);
    data?.report.report_answers.forEach((answer: any) => {
      const formId: string =
        data?.report.report_type === "two_ways" ||
        data?.report.report_type === "follow_up"
          ? answer.FlowId
          : answer.FormId;

      if (!answersByFormId[formId]) {
        answersByFormId[formId] = [];
      }

      answersByFormId[formId].push(answer);
    });
    const sortedReportAnswers = Object.values(answersByFormId).map(
      (answerForm: any) => {
        return answerForm.sort((a: any, b: any) => {
          return a.report_question_id - b.report_question_id;
        });
      }
    );
    sortedReportAnswers.sort((a: any, b: any) => {
      const aUpdatedAtTime = new Date(
        `${a[0].Date?.split("T")[0]}T${a[0].Time}`
      );
      const bUpdatedAtTime = new Date(
        `${b[0].Date?.split("T")[0]}T${b[0].Time}`
      );
      return bUpdatedAtTime.getTime() - aUpdatedAtTime.getTime();
    });

    // console.log(sortedReportAnswers, "sortedReportAnswers");
    sortedReportAnswers.length > 0 &&
      setTargetPointReportAnswers(sortedReportAnswers[0]);
    // setTargetPointReport({
    //   report_title: data?.report.report_title,
    //   questions:
    //     sortedReportAnswers.length > 0
    //       ? data?.report.report_questions
    //           .map((ques: any) => {
    //             const answers =
    //               sortedReportAnswers[0]
    //                 ?.map(
    //                   (answer: any) =>
    //                     answer.report_question_id === ques.report_question_id &&
    //                     answer?.answer_choices[0]?.text,
    //                 )
    //                 .filter((value: any) => value !== false) || [];
    //             if (answers.length === 0) {
    //               return;
    //             }
    //             if (
    //               ques.type === "essay" ||
    //               ques.type === "AI" ||
    //               ques.type === "Date"
    //             ) {
    //               return {
    //                 question_title: ques.title,
    //                 question_type: ques.type,
    //                 imgs: ques.question_pic.filter(
    //                   (pic: any) =>
    //                     pic.formId === sortedReportAnswers[0][0]?.FormId,
    //                 ),
    //                 choices: [
    //                   {
    //                     title: answers[0],
    //                     value: true,
    //                   },
    //                 ],
    //                 time: sortedReportAnswers[0][0]?.Time,
    //                 date: sortedReportAnswers[0][0]?.Date,
    //               };
    //             } else {
    //               return {
    //                 question_title: ques.title,
    //                 question_type: ques.type,
    //                 imgs: ques.question_pic.filter(
    //                   (pic: any) =>
    //                     pic.formId === sortedReportAnswers[0][0]?.FormId,
    //                 ),
    //                 choices: ques.choices.map((choice: any) => {
    //                   return {
    //                     title: choice.text,
    //                     value:
    //                       sortedReportAnswers[0]
    //                         ?.map(
    //                           (answer: any) =>
    //                             choice.question_id ===
    //                               answer.report_question_id &&
    //                             answer.answer_choices.filter(
    //                               (choiceAnswer: any) =>
    //                                 choice.text === choiceAnswer.text,
    //                             ).length > 0,
    //                         )
    //                         .filter((value: any) => value !== false)[0] ||
    //                       false,
    //                   };
    //                 }),
    //                 time: sortedReportAnswers[0][0]?.Time,
    //                 date: sortedReportAnswers[0][0]?.Date,
    //               };
    //             }
    //           })
    //           .filter((value: any) => value !== undefined)
    //       : [],
    //   user: sortedReportAnswers.length !== 0 && sortedReportAnswers[0][0]?.user,
    // });
    setTargetPointReport({
      report_title: data?.report?.report_title,
      questions:
        data?.report?.report_questions
          .map((ques: any) => {
            if (
              ques.type === "essay" ||
              ques.type === "AI" ||
              ques.type === "Date" ||
              ques.type === "signature" ||
              ques.type === "check_visitor_blackList" ||
              ques.type === "check_staff_blackList" ||
              ques.type === "rating" ||
              ques.type === "number"
            ) {
              if (
                sortedReportAnswers[0]
                  ?.map(
                    (answer: any) =>
                      answer.report_question_id === ques.report_question_id &&
                      answer.answer_choices[0]?.text
                  )
                  .filter((value: any) => value !== false)[0] === undefined &&
                ques.type !== "signature"
              ) {
                return null;
              }
              return {
                question_title: ques.title,
                question_type: ques.type,
                stage: ques.reportStage,
                imgs: ques.question_pic.filter(
                  (pic: any) => pic.formId === sortedReportAnswers[0][0].FormId
                ),
                choices: [
                  {
                    title: sortedReportAnswers[0]
                      ?.map(
                        (answer: any) =>
                          answer.report_question_id ===
                            ques.report_question_id &&
                          answer.answer_choices[0]?.text
                      )
                      .filter((value: any) => value !== false)[0],
                    value: true,
                  },
                ],
                time: sortedReportAnswers[0]?.filter(
                  (answer: any) =>
                    answer.report_question_id === ques?.report_question_id
                )[0]?.Time,
                date: sortedReportAnswers[0]?.filter(
                  (answer: any) =>
                    answer.report_question_id === ques?.report_question_id
                )[0]?.Date,
                level: ques.level,
                parent_question:
                  ques.level > 1
                    ? data?.report?.report_questions.find(
                        (question: any) =>
                          question.question_key === ques.parent_question_key
                      )
                    : null,
                parent_choice:
                  ques.level > 1
                    ? data?.report.report_questions
                        .find(
                          (question: any) =>
                            question.question_key === ques.parent_question_key
                        )
                        .choices.find(
                          (choice: any) =>
                            choice.choice_key === ques.parent_choice_key
                        )
                    : null,
              };
            } else {
              if (
                ques.choices
                  .map((choice: any) => {
                    return {
                      title: choice?.text,
                      value:
                        sortedReportAnswers[0]
                          ?.map(
                            (answer: any) =>
                              choice.question_id ===
                                answer.report_question_id &&
                              answer.answer_choices.filter(
                                (choiceAnswer: any) =>
                                  choice?.text === choiceAnswer?.text
                              ).length > 0
                          )
                          .filter((value: any) => value !== false)[0] || false,
                    };
                  })
                  .filter((choice: any) => choice.value).length === 0
              ) {
                return null;
              }
              return {
                question_title: ques.title,
                question_type: ques.type,
                stage: ques.reportStage,
                imgs: ques.question_pic.filter(
                  (pic: any) => pic.formId === sortedReportAnswers[0][0].FormId
                ),
                choices: ques.choices.map((choice: any) => {
                  return {
                    title: choice?.text,
                    value:
                      sortedReportAnswers[0]
                        ?.map(
                          (answer: any) =>
                            choice.question_id === answer.report_question_id &&
                            answer.answer_choices.filter(
                              (choiceAnswer: any) =>
                                choice?.text === choiceAnswer?.text
                            ).length > 0
                        )
                        .filter((value: any) => value !== false)[0] || false,
                  };
                }),
                time: sortedReportAnswers[0]?.filter(
                  (answer: any) =>
                    answer.report_question_id === ques?.report_question_id
                )[0]?.Time,
                date: sortedReportAnswers[0]?.filter(
                  (answer: any) =>
                    answer.report_question_id === ques?.report_question_id
                )[0]?.Date,
                level: ques.level,
                parent_question:
                  ques.level > 1
                    ? data?.report?.report_questions.find(
                        (question: any) =>
                          question.question_key === ques.parent_question_key
                      )
                    : null,
                parent_choice:
                  ques.level > 1
                    ? data?.report?.report_questions
                        .find(
                          (question: any) =>
                            question.question_key === ques.parent_question_key
                        )
                        .choices.find(
                          (choice: any) =>
                            choice.choice_key === ques.parent_choice_key
                        )
                    : null,
              };
            }
          })
          .filter((value: any) => value !== null) || [],
      user: sortedReportAnswers[0]?.map((answer: any) => answer.user),
      point: selectedPoint,
      report_category: data?.report?.report_category,
      report_type: data?.report?.report_type,
    });
  };

  // console.log(targetPointReport);

  const calculateDuration = (
    time1: string | null,
    time2: string | null
  ): string => {
    if (!time1 || !time2) {
      return "N/A";
    }

    const parseTimeString = (time: string): Date => {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      const date = new Date();
      date.setHours(hours, minutes, seconds, 0);
      return date;
    };

    const date1 = parseTimeString(time1);
    const date2 = parseTimeString(time2);

    const differenceInMilliseconds = date2.getTime() - date1.getTime();

    const hours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  };

  const getCurrentDateTimeISO = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset()); // Adjust for timezone
    return now.toISOString().slice(0, 16);
  };

  const getFloorsPositions = (floorLength: number) => {
    const positions: any = [];
    const center = [0, -2, 0];
    const centerLenght =
      floorLength % 2 === 0 ? floorLength / 2 : (floorLength - 1) / 2;
    const increment = 0.4;
    const decrement = -0.4;
    for (let i = 0; i < floorLength; i++) {
      // positions.push([0, 0, 0]);
      if (i === centerLenght) {
        positions[i] = center;
      } else if (i > centerLenght) {
        positions[i] = [0, center[1] + increment * (i - centerLenght), 0];
      } else {
        positions[i] = [0, center[1] + decrement * (centerLenght - i), 0];
      }
    }
    return positions;
  };

  // console.log(getFloorsPositions(11), "getFloorsPositions")

  const checkImage = (floorImage: string, floorName: string) => {
    let valid = true;
    const url = `${API_LINK}${floorImage}`;
    const request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.send();
    request.onload = function () {
      if (request.status === 404) {
        setBrokenFloorImages((prev) => [...prev, floorName]);
        valid = false;
        console.log(url, valid, "checkImage");
      }
    };
    return valid;
  };

  // console.log(floorImages, "floorimages");
  // console.log(brokenFloorImages, "brokenFloorImages");
  // console.log(targetPointReport, "targetPointReport");

  const getSiteLayout = async () => {
    setIsLoading(true);
    setBrokenFloorImages([]);

    // console.log(true);

    const query = [];
    if (siteId > 0) {
      query.push(`site_id=${siteId}`);
    }
    if (date.startDate) {
      query.push(`history_start_date=${date.startDate}`);
    }
    if (date.endDate) {
      query.push(`history_end_date=${date.endDate}`);
    }
    const res = await Get(
      `floors/get-site-layout?${query.join("&")}`,
      getValidToken()
    );
    if (res.error || !res.data) {
      setIsLoading(false);
      handleError(res);
      return;
    }

    const imagesTestResult =
      res.data.map((floor: any) => {
        checkImage(floor?.logo_url, floor.name);
      }) || [];
    if (imagesTestResult.includes(false)) {
      // console.log(imagesTestResult, "imagesTestResult");
    }

    // if (imagesTestResult.includes(false)) {
    //   toast.error(t("floor_images_broken"));
    //   setIsLoading(false);
    //   return;
    // }

    resetLayout && handleResetCamera();

    setFloorImages(res.data.map((floor: any) => floor.logo_url));
    setInitialPositions(getFloorsPositions(res.data.length));
    setFloorAnimation("");

    setSiteLayout(
      res.data.map((floor: any) => {
        return {
          floorTitle: floor.name,
          floorId: floor.floorId,
          floorLayoutKey: floor.floor_layout_key || "",
          pointsLength: floor.points.length || 0,
          points: floor.points
            .filter((p: any) =>
              p.point_history.length > 0
                ? p.point_history[0]?.point_position_layout?.length > 0
                : p.point_position_layout?.length > 0
            )
            .map((point: any) => {
              return {
                point_id: point.point_id,
                title: point.point_title,
                name: point.point_name,
                location: JSON.parse(
                  point.point_history.length > 0
                    ? point.point_history[0]?.point_position_layout
                    : point.point_position_layout
                ),
                color:
                  point.point_history.length === 0
                    ? "black"
                    : point.point_history[0]?.color,
                // : point.point_history.length === 0
                // ? "black"
                // : point.point_history[0]?.color,
                bio: point.bio,
                description: point.description,
                point_qrcode: point.point_qrcode,
                point_type: point.point_type,
                point_serial: point.serial,
                point_images: point?.point_images,
                point_icon: point?.point_icon,
                point_3d_location: point?.point_3d_location,
                point_3d_enabled: point?.point_3d_enabled,
              };
            }),
        };
      })
    );

    setResetFloor(!resetFloor);
    if (resetLayout) {
      if (res.data.length === 1) {
        setActive(true);
        setActiveFloor(0);
      } else {
        setActive(false);
        setActiveFloor(0);
      }
      setTargetPin("");
      setSelectedPoint(null);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (
      new Date(date.startDate) <= new Date(formatDateToISO()) ||
      new Date(date.endDate) <= new Date(formatDateToISO()) ||
      date.startDate === "" ||
      date.endDate === ""
    ) {
      siteId > 0 && siteId !== undefined && selectedService && getSiteLayout();
    } else {
      toast.error(t("date_must_be_valid"));
    }
  }, [siteId, selectedService, date]);

  useEffect(() => {
    socket?.on("RefreshLayout", () => {
      if (
        new Date(date.startDate) <= new Date(formatDateToISO()) ||
        new Date(date.endDate) <= new Date(formatDateToISO()) ||
        date.startDate === "" ||
        date.endDate === ""
      ) {
        siteId > 0 && siteId !== undefined && getSiteLayout();
      } else {
        toast.error(t("date_must_be_valid"));
      }
    });
  }, []);

  useEffect(() => {
    if (!isUser) {
      setSiteLayout([]);
      setSectors([]);
      setSiteId(0);
    }
  }, [isUser]);

  // useEffect(() => {
  //   if (filterdSegments.length === 1 && segmentId === 0) {
  //     setSegmentId(filterdSegments[0]?.id);
  //   }
  //   if (filterdSectors.length === 1 && sectorId === 0) {
  //     setSectorId(filterdSectors[0]?.asdc_client_sector_id);
  //   }
  // }, [filterdSegments, filterdSectors, siteId, sectorId, sites]);

  useEffect(() => {
    setPointReports([]);
    const getReport = async () => {
      const query = [];
      if (selectedPoint?.point_qrcode) {
        query.push(`point_qrcode=${selectedPoint.point_qrcode}`);
      }
      if (date.startDate) {
        query.push(`report_start_date=${date.startDate}`);
      }
      if (date.endDate) {
        query.push(`report_end_date=${date.endDate}`);
      }
      const res = await Get(
        `point-scan/scan-point-for-web?${query.join("&")}`,

        getValidToken()
      );
      if (res.error || !res.data || (res.status === "success" && !res.data)) {
        setTargetPointReport(null);
        if (res.message === "no services found in this site") {
          toast.error(t("there_are_no_services_in_this_site"));
        }
        return;
      }
      const data = res.data.filter((report: any) => report !== null);
      setPointReports(data);
      selectedService &&
        convertReport(
          data.filter(
            (report: any) =>
              report.report.asdc_client_service_id === selectedService
          )[0]
        );
    };

    if (selectedPoint?.point_qrcode.length > 0) {
      getReport();
    } else {
      setTargetPointReport(null);
      // setSelectedService(null);
    }
  }, [targetPin, selectedPoint, date]);

  const handleHover = (x: string) => {
    !active && setHoveredMesh(x);
  };

  const handleclick = (n: number) => {
    setColorFilter("");
    if (!active) {
      for (let i = n + 1; i < elementsRef.current?.length; i++) {
        up(elementsRef.current[i]);
        setTimeout(() => {
          if (elementsRef.current[i]) {
            elementsRef.current[i].visible = false;
          }
          // elementsRef.current[i].visible = false;
        }, 300);
      }
      for (let i = n - 1; i >= 0; i--) {
        down(elementsRef.current[i]);
        setTimeout(() => {
          if (elementsRef.current[i]) {
            elementsRef.current[i].visible = false;
          }
          // elementsRef.current[i].visible = false;
        }, 300);
      }
      animateRotate(elementsRef.current[n], [5.7, 0.05, 0.07]);
      // animateRotationReset(elementsRef.current[n], [-0.6, 0.05, 0.07], 1000);
      animatePosition(elementsRef.current[n]);
      setTimeout(() => {
        setActive(true);
      }, 500);
      setActiveFloor(n);
      elementsRef.current.map((ref: any, i: number) => {
        if (i !== n) {
          animateRotate(ref, [5.7, 0.05, 0.07]);
          // animateRotationReset(ref, [-0.6, 0.05, 0.07], 1000);
        }
      });
    }
  };

  const swapUp = () => {
    if (
      activeFloor !== null &&
      activeFloor < elementsRef.current?.length - 1 &&
      targetPin === ""
    ) {
      setFloorAnimation("up");
      if (elementsRef.current[activeFloor - 1]) {
        down(elementsRef.current[activeFloor]);
        down(elementsRef.current[activeFloor + 1]);
        elementsRef.current[activeFloor - 1].visible = true;
        animatePosition(elementsRef.current[activeFloor + 1]);
        elementsRef.current.map((ref: any, i: number) => {
          if (i !== activeFloor + 1 && ref.visible) {
            ref.visible = false;
          }
        });
      }
      setActiveFloor(activeFloor + 1);
      const timeOut = setTimeout(() => {
        setFloorAnimation("");
      }, 200);
      return () => clearTimeout(timeOut);
    }
  };
  const swapDown = () => {
    if (activeFloor !== null && activeFloor > 0 && targetPin === "") {
      setFloorAnimation("down");
      if (elementsRef.current[activeFloor - 1]) {
        up(elementsRef.current[activeFloor]);
        up(elementsRef.current[activeFloor - 1]);
        elementsRef.current[activeFloor - 1].visible = true;
        animatePosition(elementsRef.current[activeFloor - 1]);
        elementsRef.current.map((ref: any, i: number) => {
          if (i !== activeFloor - 1 && ref.visible) {
            ref.visible = false;
          }
        });
      }
      setActiveFloor(activeFloor - 1);
      const timeOut = setTimeout(() => {
        setFloorAnimation("");
      }, 200);
      return () => clearTimeout(timeOut);
    }
  };

  // console.log(activeFloor, "activeFloor");
  // console.log(floorAnimation, "FloorAnimation");
  // console.log(elementsRef, "elementsRef");

  const handlePinClick = (point: Point) => {
    if (point?.point_id === selectedPoint?.point_id) return;
    if (!selectedPoint) {
      setSelectedPoint(point);
      setTargetPin(point.name);
      setResetFloor(!resetFloor);
    } else {
      setTargetPin("");
      setSelectedPoint(null);
      const timeOut = setTimeout(() => {
        setTargetPin(point.name);
        setSelectedPoint(point);
        setResetFloor(!resetFloor);
      }, 300);
      return () => clearTimeout(timeOut);
    }
  };

  const display_site_layout_3d_point = (
    sectorId: number,
    segmentId: number,
    siteId: number,
    selectedService: number
  ) => {
    setSegmentId(segmentId);
    setSectorId(sectorId);
    setSiteId(siteId);
    setSelectedService(selectedService);
  };

  useEffect(() => {
    const handleSearchClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.id === "searchBtn" || target.classList.contains("searchBtn")) {
        setSearchActive(true);
        document.getElementById("search")?.focus();
      } else {
        setSearchActive(false);
        setSearchValue("");
      }
    };
    document.addEventListener("click", handleSearchClick);
    () => document.removeEventListener("click", handleSearchClick);
  }, []);

  const resetlayers = () => {
    setColorFilter("");
    setTargetPin("");
    setFloorAnimation("");
    setSelectedPoint(null);
    elementsRef.current.forEach((ref: any, i: number) => {
      if (ref) {
        animateRotationReset(ref, initialRotation, 500);
        animatePositionReset(ref, initialPositions[i]);
        ref.visible = true;
      }
    });
    setActive(false);
    setActiveFloor(0);
  };

  const handleResetCamera = () => {
    const defaultCameraPosition = [1, 6, 8];
    const defaultCameraRotation = [0, 0, 0];
    controlsRef?.current?.reset();
    cameraRef?.current?.position.set(...defaultCameraPosition);
    cameraRef?.current?.rotation.set(...defaultCameraRotation);
  };

  // const animate = (
  //   mesh: Mesh,
  //   duration: number,
  //   updateFunction: (progress: number) => void,
  //   onComplete?: () => void
  // ) => {
  //   let startTime: number | null = null;

  //   const animateFrame = (timestamp: number) => {
  //     if (!startTime) {
  //       startTime = timestamp;
  //     }

  //     const elapsed = timestamp - startTime;
  //     const progress = Math.min(elapsed / duration, 1);

  //     updateFunction(progress);

  //     if (progress < 1) {
  //       requestAnimationFrame(animateFrame);
  //     } else {
  //       startTime = null;
  //       if (onComplete) {
  //         onComplete();
  //       }
  //     }
  //   };

  //   requestAnimationFrame(animateFrame);
  // };

  // Animation functions
  const up = (mesh: Mesh) => {
    let startTime: number | null = null;
    const duration = 700;

    const animate = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }
      const progress = (timestamp - startTime) / duration;
      if (progress < 1) {
        // Continue the animation
        mesh?.translateZ(0.2);
        requestAnimationFrame(animate);
      } else {
        // Animation completed
        startTime = null;
      }
    };
    requestAnimationFrame(animate);
  };

  const down = (mesh: Mesh) => {
    let startTime: number | null = null;
    const duration = 700;

    const animate = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const progress = (timestamp - startTime) / duration;

      if (progress < 1) {
        // Continue the animation
        mesh?.translateZ(-0.2);
        requestAnimationFrame(animate);
      } else {
        // Animation completed
        startTime = null;
      }
    };
    requestAnimationFrame(animate);
  };
  // // targetRotation [-0.6, 0.05, 0.07]
  //   const animateRotate = (mesh: Mesh, targetRotation?: any) => {
  //     let startTime: number | null = null;
  //     const duration = 500;

  //     const animate = (timestamp: number) => {
  //       if (!startTime) {
  //         startTime = timestamp;
  //       }

  //       const progress = (timestamp - startTime) / duration;

  //       if (progress < 1) {
  //         // Continue the animation
  //         mesh.rotateX(0.028);
  //         mesh.rotateY(-0.01);
  //         mesh.rotateZ(-0.02);
  //         requestAnimationFrame(animate);
  //       } else {
  //         // Animation completed
  //         startTime = null;
  //       }
  //     };
  //     requestAnimationFrame(animate);
  //   };

  const animateRotate = (mesh: Mesh, targetRotation?: number[]) => {
    let startTime: number | null = null;
    const duration = 500;

    const startRotation = {
      x: mesh.rotation.x,
      y: mesh.rotation.y,
      z: mesh.rotation.z,
    };

    const targetRotationX = targetRotation?.[0] || 0;
    const targetRotationY = targetRotation?.[1] || 0;
    const targetRotationZ = targetRotation?.[2] || 0;

    const animate = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const progress = Math.min((timestamp - startTime) / duration, 1);

      // Interpolate between start and target rotation
      const currentRotationX =
        startRotation.x + (targetRotationX - startRotation.x) * progress;
      const currentRotationY =
        startRotation.y + (targetRotationY - startRotation.y) * progress;
      const currentRotationZ =
        startRotation.z + (targetRotationZ - startRotation.z) * progress;

      mesh.rotation.set(currentRotationX, currentRotationY, currentRotationZ);

      if (progress < 1) {
        // Continue the animation
        requestAnimationFrame(animate);
      } else {
        // Animation completed
        startTime = null;
      }
    };

    requestAnimationFrame(animate);
  };

  const animatePosition = (mesh: Mesh) => {
    const targetPosition =
      initialPositions[(initialPositions.length / 2).toFixed(0) as any];
    let startTime: number | null = null;
    const duration = 1200;

    const animate = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }
      const progress = (timestamp - startTime) / duration;

      if (progress < 1) {
        // Continue the animation
        const newPosition = targetPosition.map(
          (originalCoord, i) =>
            mesh?.position?.getComponent(i) +
            (originalCoord - mesh?.position?.getComponent(i)) * progress
        ) as [number, number, number];

        mesh?.position?.set(...newPosition);

        requestAnimationFrame(animate);
      } else {
        // Animation completed
        startTime = null;
      }
    };
    requestAnimationFrame(animate);
  };

  // Reset animation functions
  const animatePositionReset = (
    mesh: Mesh,
    targetPosition: [number, number, number]
  ) => {
    let startTime: number | null = null;
    const duration = 1000;

    const animate = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const progress = (timestamp - startTime) / duration;

      if (progress < 1) {
        // Continue the animation
        const newPosition = targetPosition.map(
          (originalCoord, i) =>
            mesh?.position?.getComponent(i) +
            (originalCoord - mesh?.position?.getComponent(i)) * progress
        ) as [number, number, number];

        mesh?.position?.set(...newPosition);

        requestAnimationFrame(animate);
      } else {
        // Animation completed
        startTime = null;
      }
    };
    requestAnimationFrame(animate);
  };

  const animateRotationReset = (
    mesh: Mesh,
    targetRotation: [number, number, number],
    duration: number
  ) => {
    let startTime: number | null = null;
    // const duration = 500;

    const animate = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const progress = (timestamp - startTime) / duration;

      if (progress < 1) {
        // Continue the animation
        const newRotation = new Euler();
        newRotation.set(
          targetRotation[0],
          targetRotation[1],
          targetRotation[2] * progress
        );
        mesh.rotation.set(newRotation.x, newRotation.y, newRotation.z);

        requestAnimationFrame(animate);
      } else {
        // Animation completed
        startTime = null;
      }
    };
    requestAnimationFrame(animate);
  };

  const changeSegment = (segmentId: number) => {
    setSiteId(0);
    setSectorId(0);
    setResetLayout(true);
    setDate(defaltDate);
    setSegmentId(segmentId);
    const newSectors = filterdSectors.filter(
      (sector: any) => sector.segment_id === segmentId
    );
    if (newSectors.length === 1) {
      changeSector(newSectors[0]?.asdc_client_sector_id);
    }
  };

  const changeSector = (sectorId: number) => {
    setSiteId(0);
    setResetLayout(true);
    setDate(defaltDate);
    setSectorId(sectorId);
    const newSites = sites.filter(
      (site: any) => site.asdc_client_sector_id === sectorId
    );
    if (newSites.length === 1) {
      changeSite(newSites[0]?.site_id);
    }
  };

  const changeSite = (siteId: number) => {
    setResetLayout(true);
    setDate(defaltDate);
    setSiteId(siteId);
    if (selectedService && selectedService > 0) {
      setFilter({ ...filter, selects: false });
    }
  };

  useEffect(() => {
    if (servicesOptions.length == 1) {
      setSelectedService(servicesOptions[0].value);
    }
  }, [siteId, sectorId, segmentId]);

  // console.log(sitesOptions.map((sector) => {
  //   return sector.options.find((site: any) => site.value === siteId);
  // }) , "select");

  // console.log(targetPointReport?.questions, "targetPointReport questions");

  return (
    <>
      <div
        className={`w-full -mt-6 -mb-20 relative overflow-hidden max-md:hidden ${
          opacity ? "threeD" : "h-0"
        }`}
      >
        {/* site select and date picker */}
        <div
          className={`absolute top-4 flex gap-4 items-center justify-center z-[999] min-h-20
          ${i18next.language === "en" ? "left-4" : "right-4"}`}
        >
          <button
            className="text-3xl relative p-2"
            onClick={() => setFilter({ ...filter, selects: !filter.selects })}
          >
            {filter.selects && (
              <IoIosAddCircleOutline className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            )}
            {!filter.selects && (
              <IoIosAddCircle className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            )}
          </button>
          <div
            className={`flex items-center gap-3 ${
              filter.selects ? "" : "w-0 overflow-hidden"
            }`}
          >
            {/* <Select
            className="outline-none w-44"
            onChange={(selectedOption: any) => {
              setResetLayout(true);
              setDate(defaltDate);
              setSiteId(selectedOption?.value);
            }}
            value={sitesOptions.map((sector) => {
              return sector.options.find((site: any) => site.value === siteId);
            })}
            options={sitesOptions}
            placeholder={t("select_site")}
            key={`${siteId}${isUser}`}
            formatGroupLabel={formatGroupLabel}
          /> */}
            <Select
              className="outline-none w-40 z-[1000] relative"
              onChange={(selectedOption: any) => {
                // setSiteId(0);
                // setSectorId(0);
                // setResetLayout(true);
                // setDate(defaltDate);
                // setSegmentId(selectedOption?.value);
                changeSegment(selectedOption?.value);
              }}
              value={segmentsOptions.find(
                (segment) => segment.value === segmentId
              )}
              options={segmentsOptions}
              placeholder={t("select_segment")}
              key={`segment:${segmentId}${isUser}`}
              styles={{
                singleValue: (provided) => ({
                  ...provided,
                  fontSize: "0.8rem",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  fontSize: "0.8rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }),
              }}
            />
            {segmentId !== 0 && (
              <Select
                className="outline-none w-40 z-[1000] relative"
                onChange={(selectedOption: any) => {
                  // setSiteId(0);
                  // setResetLayout(true);
                  // setDate(defaltDate);
                  // setSectorId(selectedOption?.value);
                  changeSector(selectedOption?.value);
                }}
                value={sectorsOptions.find(
                  (sector) => sector.value === sectorId
                )}
                options={sectorsOptions}
                placeholder={t("select_sector")}
                key={`sector:${sectorId}${isUser}`}
                styles={{
                  singleValue: (provided) => ({
                    ...provided,
                    fontSize: "0.8rem",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            )}
            {sectorId !== 0 && (
              <Select
                className="outline-none w-40 z-[1000] relative"
                onChange={(selectedOption: any) => {
                  // setResetLayout(true);
                  // setDate(defaltDate);
                  // setSiteId(selectedOption?.value);
                  // if (selectedService && selectedService > 0) {
                  //   setFilter({ ...filter, selects: false });
                  // }
                  changeSite(selectedOption?.value);
                }}
                value={sitesOptions.find((site: any) => site.value === siteId)}
                options={sitesOptions}
                placeholder={t("select_site")}
                key={`site:${siteId}${isUser}`}
                styles={{
                  singleValue: (provided) => ({
                    ...provided,
                    fontSize: "0.8rem",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            )}
            <Select
              className="w-40 z-[1000] relative"
              options={servicesOptions}
              value={servicesOptions?.find(
                (option: any) => option.value === selectedService
              )}
              placeholder={t("select_service")}
              onChange={(selectedOption: any) => {
                setSelectedService(selectedOption?.value);
                if (pointReports.length > 0) {
                  convertReport(
                    pointReports.filter(
                      (report: any) =>
                        report.report.asdc_client_service_id ===
                        selectedOption?.value
                    )[0]
                  );
                }
                if (siteId > 0) {
                  setFilter({ ...filter, selects: false });
                }
              }}
              styles={{
                singleValue: (provided) => ({
                  ...provided,
                  fontSize: "0.8rem",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  fontSize: "0.7rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }),
              }}
            />
          </div>
          <div className={`hidden 3xl:flex items-center gap-1 `}>
            <label className="text-sm text-text">{t("from")}:</label>
            <input
              type="datetime-local"
              className="!w-28"
              onChange={(e) => {
                // console.log(e.target.value, "date");
                setResetLayout(false);
                setDate({ ...date, startDate: e.target.value });
              }}
              value={date.startDate}
              key={"Date :" + selectedPoint?.point_qrcode + " " + targetPin}
              // max={formatDateToISO()}
              min={new Date().toISOString().slice(0, 16)}
            />
          </div>
          <div className={`hidden 3xl:flex items-center gap-1`}>
            <label className="text-sm text-text">{t("to")}:</label>
            <input
              type="datetime-local"
              className="!w-28"
              onChange={(e) => {
                // console.log(e.target.value, "date");
                setResetLayout(false);
                setDate({ ...date, endDate: e.target.value });
              }}
              value={date.endDate}
              key={"Date :" + selectedPoint?.point_qrcode + " " + targetPin}
              // max={formatDateToISO()}
              min={date.startDate} // Prevent past dates before "From"
            />
          </div>
          {/* <button
            onClick={() => setFilter({ ...filter, dates: !filter.dates })}
            className={`3xl:hidden`}
          >
            <CiFilter className="text-3xl" />
          </button> */}
          {/* floor title */}
          <div
            className={`text-3xl font-bold duration-300 ${
              !active && "hidden"
            } `}
          >
            {siteLayout[activeFloor !== null ? activeFloor : 0]?.floorTitle}
          </div>
        </div>
        {/* Second Row */}
        {filter.selects && (
          <div className="absolute top-24 left-4 z-[998] flex items-center gap-4 3xl:hidden">
            <div className={`flex items-center gap-1`}>
              <label className="text-sm text-text">{t("from")}:</label>
              <input
                type="datetime-local"
                className="!w-28"
                onChange={(e) => {
                  // console.log(e.target.value, "date");
                  setResetLayout(false);
                  setDate({ ...date, startDate: e.target.value });
                }}
                value={date.startDate}
                key={"Date :" + selectedPoint?.point_qrcode + " " + targetPin}
                max={formatDateToISO()}
              />
            </div>
            <div className={`flex items-center gap-1`}>
              <label className="text-sm text-text">{t("to")}:</label>
              <input
                type="datetime-local"
                className="!w-28"
                onChange={(e) => {
                  // console.log(e.target.value, "date");
                  setResetLayout(false);
                  setDate({ ...date, endDate: e.target.value });
                }}
                value={date.endDate}
                key={"Date :" + selectedPoint?.point_qrcode + " " + targetPin}
                max={formatDateToISO()}
              />
            </div>
          </div>
        )}
        {/* no floors */}
        {siteLayout.length === 0 && !isLoading && (
          <div className="mt-52">
            <NoData message={t("no_floors")} />
          </div>
        )}
        {!selectedService && siteLayout.length > 0 && (
          <div className="mt-52">
            <NoData message={t("select_service_first")} />
          </div>
        )}
        {/* 3D layout */}
        {!isLoading && brokenFloorImages.length === 0 && selectedService && (
          <Canvas
            style={{ width: "100%", height: "95%" }}
            className={`!bg-background duration-300 mt-20 ${
              targetPin !== "" && i18next.language === "en" && "-translate-x-52"
            } ${
              targetPin !== "" && i18next.language === "ar" && "translate-x-52"
            } ${(active || siteLayout.length === 0) && "hidden"}`}
            key={siteId + "Layout"}
          >
            <PerspectiveCamera
              makeDefault
              position={[1, 6, 8]}
              fov={initialPositions.length > 7 ? 60 : 34}
              near={0.1}
              ref={cameraRef}
              key={active + " " + activeFloor}
            />
            <Suspense fallback={<CanvasLaoder />}>
              <OrbitControls
                enableZoom={true}
                enablePan={true}
                // enableRotate={true}
                enableRotate={!active}
                minPolarAngle={!active ? Math.PI / 6 : Math.PI / 4}
                maxPolarAngle={!active ? (3 * Math.PI) / 6 : (3 * Math.PI) / 8}
                minAzimuthAngle={!active ? -Math.PI / 8 : -Math.PI / 12}
                maxAzimuthAngle={!active ? Math.PI / 5 : Math.PI / 8}
                ref={controlsRef}
              />
              <ambientLight intensity={active ? -3 : 0.8} />
              <directionalLight
                position={[0, 10, 0]}
                intensity={active ? 3.5 : 2}
              />
              <group
                position={
                  siteLayout?.length > 1 ? [0, 2.7, 0.5] : [0, 3.7, 0.5]
                }
              >
                {siteLayout?.map((floor: Floor, i: number) => {
                  return (
                    <mesh
                      key={i}
                      scale={[1.25, 1.25, 1.25]}
                      rotation={
                        siteLayout?.length > 1
                          ? initialRotation
                          : [-0.6, 0.05, 0.07]
                      }
                      position={initialPositions[i]}
                      ref={(el) => (elementsRef.current[i] = el)}
                      onClick={(e) => {
                        !active && e.stopPropagation();
                        handleclick(i);
                      }}
                      onPointerOver={(e) => {
                        e.stopPropagation();
                        handleHover(i === 0 ? "G" : `${i}`);
                        typeof document != "undefined" &&
                          (document.body.style.cursor = "pointer");
                      }}
                      onPointerOut={(e) => {
                        e.stopPropagation();
                        handleHover("");
                        typeof document != "undefined" &&
                          (document.body.style.cursor = "auto");
                      }}
                    >
                      <planeGeometry args={initArgs} attach="geometry" />
                      <meshStandardMaterial
                        map={mapLoader[i] ?? ""}
                        attach="material"
                        side={DoubleSide}
                        color={
                          hoveredMesh === `${i}`
                            ? "hsl(0,0%,95.69%)"
                            : hoveredMesh === "G" && i === 0
                              ? "hsl(0,0%,95.69%)"
                              : "white"
                        }
                      />
                      {/* {floor.points.map((point: Point, i: number) => {
                      return (
                        <group
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePinClick(point);
                          }}
                          key={i}
                        >
                          {point.point_type === "single_location" && (
                            <Location
                              active={active}
                              position={[...point.location[0], zDimaintion]}
                              color={
                                targetPin !== "" && targetPin !== point.name
                                  ? point.color + "Opacity"
                                  : point.color
                              }
                            />
                          )}
                          {point.point_type === "multiple_location" && (
                            <MultiLocation
                              point={point}
                              zDimaintion={zDimaintion}
                              color={
                                targetPin !== "" && targetPin !== point.name
                                  ? point.color + "Opacity"
                                  : point.color
                              }
                            />
                          )}
                        </group>
                      );
                    })} */}
                    </mesh>
                  );
                })}
              </group>
            </Suspense>
          </Canvas>
        )}
        {/* floors numbers */}
        {brokenFloorImages.length === 0 && selectedService && (
          <div
            className={`floor-controller absolute top-[40%] -translate-y-1/2 flex flex-col-reverse gap-2 h-[220px] overflow-auto ${
              active && "hidden"
            } ${i18next.language === "en" ? "left-64" : "left-52"}`}
          >
            {siteLayout?.map((floor: Floor, i: number) => (
              <span
                className={`bg-[#E2E2E2] text-gray-700 text-3xl w-6 h-8 grid place-content-center cursor-pointer ${
                  hoveredMesh === `${i}` && i > 0
                    ? "opacity-90"
                    : hoveredMesh === "G" && i === 0
                      ? "opacity-90"
                      : "opacity-50"
                }`}
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  handleclick(i);
                }}
                onPointerOver={(e) => {
                  e.stopPropagation();
                  handleHover(i === 0 ? "G" : `${i}`);
                }}
                onPointerOut={(e) => {
                  e.stopPropagation();
                  handleHover("");
                }}
              >
                {floor?.floorLayoutKey}
              </span>
            ))}
          </div>
        )}
        {/* one floor view */}
        {!isLoading &&
          active &&
          brokenFloorImages.length === 0 &&
          siteId &&
          selectedService && (
            <div
              className={`mt-40 ms-8 z-[100] ${selectedPoint ? "w-[80%]" : ""} ${
                targetPin !== "" &&
                i18next.language === "en" &&
                "-translate-x-28 duration-300"
              } ${
                targetPin !== "" &&
                i18next.language === "ar" &&
                "translate-x-28 duration-300"
              } ${floorAnimation === "up" && "translate-y-[45rem] duration-75"} ${
                floorAnimation === "down" && "-translate-y-[45rem] duration-75"
              }`}
            >
              <FloorComponent
                image={floorImages[activeFloor]}
                floor={targetFloor()}
                status={"view"}
                handlePinClick={handlePinClick}
                selectedPoint={selectedPoint}
                key={`${resetFloor ? "true" : "false"}`}
                width={selectedPoint ? "!w-[50vw]" : undefined}
                selectedSegment={segmentId}
                selectedSector={sectorId}
                selectedSite={siteId}
                selectedService={selectedService!}
                display_site_layout_3d_point={display_site_layout_3d_point}
              />
            </div>
          )}
        {/* loading floors */}
        {isLoading && (
          <div className="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-primary mx-auto mt-80" />
        )}
        {/* points keys */}
        {siteId && selectedService ? (
          <div
            className={`absolute xl:top-[45%] lg:top-[50%] top-[65%] -translate-y-1/2 flex-col gap-3 text-[#5e5e64] flex duration-300 text-[0.60rem] xl:text-xs 2xl:text-base ${
              targetPin !== "" && i18next.language === "en"
                ? "-translate-x-44"
                : targetPin !== "" && i18next.language === "ar"
                  ? "translate-x-44"
                  : ""
            } ${i18next.language === "en" ? "left-4" : "right-4"}`}
          >
            <div className="">{t("keys")}:</div>
            <div
              className={`flex justify-center items-center flex-col mx-1 text-text rounded-lg bg-secondary w-20 h-8 xl:w-24 xl:h-10 2xl:w-32 2xl:h-14 duration-300 cursor-pointer ${
                colorFilter !== "" && "opacity-50"
              } ${(hoveredMesh === "" || active) && "h-8 xl:h-10 2xl:h-14"}`}
              onClick={() => {
                if (colorFilter !== "" && active) {
                  setColorFilter("");
                  setResetFloor(!resetFloor);
                }
              }}
            >
              <span className="">{t("all")}</span>
              {active ? (
                <span className="">
                  ({" "}
                  <span className="font-bold">
                    {colors[activeFloor]?.length}
                  </span>{" "}
                  / {siteLayout[activeFloor]?.pointsLength} )
                  {/* / {inspectionPointsCount} ) */}
                </span>
              ) : (
                <span className={`${hoveredMesh === "" && "hidden"}`}>
                  ({" "}
                  <span className="font-bold">
                    {hoveredMesh !== "" &&
                      colors[hoveredMesh == "G" ? 0 : +hoveredMesh]?.length}
                  </span>{" "}
                  /{" "}
                  {
                    siteLayout[hoveredMesh == "G" ? 0 : +hoveredMesh]
                      ?.pointsLength
                  }{" "}
                  ){/* / {inspectionPointsCount} ) */}
                </span>
              )}
            </div>
            <div
              className={`flex justify-center items-center flex-col mx-1 text-white rounded-lg bg-[#28c66f] w-20 h-8 xl:w-24 xl:h-10 2xl:w-32 2xl:h-14 duration-300 cursor-pointer ${
                colorFilter !== "green" && colorFilter !== "" && "opacity-50"
              } ${(hoveredMesh === "" || active) && "h-8 xl:h-10 2xl:h-14"}`}
              onClick={() => {
                if (colorFilter !== "green" && active) {
                  setColorFilter("green");
                  setResetFloor(!resetFloor);
                }
              }}
            >
              <span className="">{t("normal")}</span>
              {active ? (
                <span className="">
                  ({" "}
                  <span className="font-bold">
                    {color1[activeFloor]?.length}
                  </span>{" "}
                  / {siteLayout[activeFloor]?.pointsLength} )
                </span>
              ) : (
                <span className={`${hoveredMesh === "" && "hidden"}`}>
                  ({" "}
                  <span className="font-bold">
                    {hoveredMesh !== "" &&
                      color1[hoveredMesh == "G" ? 0 : +hoveredMesh]?.length}
                  </span>{" "}
                  /{" "}
                  {
                    siteLayout[hoveredMesh == "G" ? 0 : +hoveredMesh]
                      ?.pointsLength
                  }{" "}
                  )
                </span>
              )}
            </div>
            <div
              className={`flex justify-center items-center flex-col mx-1 text-white rounded-lg bg-[#ff9e3f] w-20 h-8 xl:w-24 xl:h-10 2xl:w-32 2xl:h-14 duration-300 cursor-pointer ${
                colorFilter !== "orange" && colorFilter !== "" && "opacity-50"
              } ${(hoveredMesh === "" || active) && "h-8 xl:h-10 2xl:h-14"}`}
              onClick={() => {
                if (colorFilter !== "orange" && active) {
                  setColorFilter("orange");
                  setResetFloor(!resetFloor);
                }
              }}
            >
              <span className="">{t("up_normal")}</span>
              {active ? (
                <span className="">
                  ({" "}
                  <span className="font-bold">
                    {color2[activeFloor]?.length}
                  </span>{" "}
                  / {siteLayout[activeFloor]?.pointsLength} )
                </span>
              ) : (
                <span className={`${hoveredMesh === "" && "hidden"}`}>
                  ({" "}
                  <span className="font-bold">
                    {hoveredMesh !== "" &&
                      color2[hoveredMesh == "G" ? 0 : +hoveredMesh]?.length}
                  </span>{" "}
                  /{" "}
                  {
                    siteLayout[hoveredMesh == "G" ? 0 : +hoveredMesh]
                      ?.pointsLength
                  }{" "}
                  )
                </span>
              )}
            </div>
            <div
              className={`flex justify-center items-center flex-col mx-1 text-white rounded-lg bg-[#ea5456] w-20 h-8 xl:w-24 xl:h-10 2xl:w-32 2xl:h-14 duration-300 cursor-pointer ${
                colorFilter !== "red" && colorFilter !== "" && "opacity-50"
              } ${(hoveredMesh === "" || active) && "h-8 xl:h-10 2xl:h-14"}`}
              onClick={() => {
                if (colorFilter !== "red" && active) {
                  setColorFilter("red");
                  setResetFloor(!resetFloor);
                }
              }}
            >
              <span className="">{t("extreme")}</span>
              {active ? (
                <span className="">
                  ({" "}
                  <span className="font-bold">
                    {color3[activeFloor]?.length}
                  </span>{" "}
                  / {siteLayout[activeFloor]?.pointsLength} )
                </span>
              ) : (
                <span className={`${hoveredMesh === "" && "hidden"}`}>
                  ({" "}
                  <span className="font-bold">
                    {hoveredMesh !== "" &&
                      color3[hoveredMesh == "G" ? 0 : +hoveredMesh]?.length}
                  </span>{" "}
                  /{" "}
                  {
                    siteLayout[hoveredMesh == "G" ? 0 : +hoveredMesh]
                      ?.pointsLength
                  }{" "}
                  )
                </span>
              )}
            </div>
            <div
              className={`flex justify-center items-center flex-col mx-1 text-white rounded-lg bg-gray-800 w-20 h-8 xl:w-24 xl:h-10 2xl:w-32 2xl:h-14 duration-300 cursor-pointer ${
                colorFilter !== "black" && colorFilter !== "" && "opacity-50"
              } ${(hoveredMesh === "" || active) && "h-8 xl:h-10 2xl:h-14"}`}
              onClick={() => {
                if (colorFilter !== "black" && active) {
                  setColorFilter("black");
                  setResetFloor(!resetFloor);
                }
              }}
            >
              <span className="">{t("undefined_t")}</span>
              {active ? (
                <span className="">
                  ({" "}
                  <span className="font-bold">
                    {color4[activeFloor]?.length}
                  </span>{" "}
                  / {siteLayout[activeFloor]?.pointsLength} )
                </span>
              ) : (
                <span className={`${hoveredMesh === "" && "hidden"}`}>
                  ({" "}
                  <span className="font-bold">
                    {hoveredMesh !== "" &&
                      color4[hoveredMesh == "G" ? 0 : +hoveredMesh]?.length}
                  </span>{" "}
                  /{" "}
                  {
                    siteLayout[hoveredMesh == "G" ? 0 : +hoveredMesh]
                      ?.pointsLength
                  }{" "}
                  )
                </span>
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {/* control buttons */}
        <div
          className={`absolute top-11 w-40 flex flex-col justify-center items-end gap-3 z-[99999] ${
            i18next.language === "en" ? "right-4" : "left-4"
          }`}
        >
          {/* search */}
          <div className={`flex items-start gap-1 relative`}>
            <div
              className={`${
                !searchActive && i18next.language === "en"
                  ? "translate-x-28"
                  : !searchActive && i18next.language === "ar"
                    ? "-translate-x-28"
                    : "translate-x-0"
              }`}
            >
              <input
                type="text"
                id="search"
                disabled={!searchActive}
                className={`block text-sm p-0 h-10 px-3 duration-200 ${
                  searchActive ? "max-w-[230px]" : "max-w-0"
                }`}
                value={searchActive ? searchValue : ""}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              />
              <div className="w-full bg-white max-h-80 overflow-y-auto !z-[99999]">
                {searchActive &&
                  siteLayout?.map((floor: Floor, i: number) => {
                    if (searchValue === "") return null;
                    if (active && activeFloor !== i) return null;
                    return (
                      <div key={i} className="px-3 bg-gray-100">
                        {floor?.points.map((point: Point, index: number) => {
                          if (
                            point.name
                              .toLowerCase()
                              .includes(searchValue.toLowerCase()) ||
                            point.point_serial
                              .toLowerCase()
                              .includes(searchValue.toLowerCase())
                          ) {
                            return (
                              <div
                                key={index}
                                className="flex items-center justify-between cursor-pointer rounded-md p-1 border-b-[1px] border-solid border-gray-300 hover:bg-gray-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleclick(i);
                                  handlePinClick(point);
                                  setSearchActive(false);
                                  setSearchValue("");
                                }}
                              >
                                <div className="">
                                  <span className="text-xs">
                                    {`${point.name}`}
                                  </span>
                                  <span className="text-[0.50rem]">
                                    {`${point.point_serial}`}
                                  </span>
                                </div>
                                <span className="text-[0.65rem]">
                                  ({floor?.floorTitle})
                                </span>
                              </div>
                            );
                          }
                        })}
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="searchBtn z-10 grid place-content-center w-[44px] h-[44px] text-4xl text-white bg-[#c4c4c7] rounded-full cursor-pointer duration-200">
              <IoIosSearch className="w-7 h-7" id="searchBtn" />
            </div>
          </div>
          {/* layout control */}
          {active && siteLayout?.length > 1 && targetPin === "" && (
            <>
              <span
                className={`grid place-content-center p-3 text-4xl text-white bg-[#c4c4c7] rounded-full duration-200 ${
                  activeFloor == siteLayout?.length - 1 || targetPin !== ""
                    ? "cursor-not-allowed opacity-25"
                    : "cursor-pointer hover:text-gray-700"
                }`}
                onClick={swapUp}
              >
                <IoIosArrowUp />
              </span>
              <span
                className={`grid place-content-center p-3 text-4xl text-white hover:text-gray-700 bg-[#c4c4c7] rounded-full duration-200 cursor-pointer`}
                onClick={resetlayers}
              >
                <LuLayers />
              </span>
              <span
                className={`grid place-content-center p-3 text-4xl text-white bg-[#c4c4c7] rounded-full duration-200 ${
                  activeFloor == 0 || targetPin !== ""
                    ? "cursor-not-allowed opacity-25"
                    : "cursor-pointer hover:text-gray-700"
                }`}
                onClick={swapDown}
              >
                <IoIosArrowDown />
              </span>
            </>
          )}
        </div>

        {/* point details */}
        <div
          className={`absolute top-0 mt-24 pb-44 z-[9999] h-[100%] rounded-xl w-1/3 bg-[#d7d7dc] overflow-y-auto duration-500 ${
            targetPin == "" &&
            i18next.language === "en" &&
            "translate-x-[200rem] opacity-0"
          } ${
            targetPin == "" &&
            i18next.language === "ar" &&
            "-translate-x-[200rem] opacity-0"
          } ${i18next.language === "ar" ? "left-0" : "right-0"}`}
        >
          <div className={`relative`}>
            <span
              className={`fixed end-20 top-64 w-fit p-3 md:text-lg lg:text-xl xl:text-4xl text-white hover:text-gray-700 bg-[#c4c4c7] rounded-full cursor-pointer duration-200`}
              onClick={() => {
                setTargetPin("");
                setSelectedPoint(null);
                setTargetPointReport(null);
                setSelectedReport(0);
                setPointReports([]);
                setResetFloor(!resetFloor);
              }}
            >
              <IoCloseSharp />
              {/* <Icon src={close} className="w-6 h-6" /> */}
            </span>
            <div className="mt-5">
              <div className="flex flex-col gap-3 pt-6">
                {targetPointReport?.questions.length > 0 && (
                  <div className="flex items-center justify-center gap-6 flex-wrap">
                    <div
                      className={`mt-6 ${
                        targetPointReport?.user.deleted && "relative"
                      }`}
                    >
                      <Image
                        className="rounded-full w-[150px] h-[150px] object-cover mx-auto"
                        src={targetPointReport?.user.profile_pic}
                        alt={targetPointReport?.user.asdc_client_user_name}
                      />
                      {targetPointReport?.user.deleted && (
                        <span className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center text-white text-xs font-bold rounded-full">
                          {t("deleted")}
                        </span>
                      )}
                    </div>
                    <div className="flex flex-col justify-center gap-3">
                      <p className="font-bold mb-2">
                        Email:{" "}
                        <span className="ml-1 font-normal">
                          {targetPointReport?.user.asdc_client_user_email}
                        </span>
                      </p>
                      <p className="font-bold mb-2">
                        User Phone:{" "}
                        <span className="ml-1 font-normal">
                          {targetPointReport?.user.asdc_client_user_mobile}
                        </span>
                      </p>
                      <p className="font-bold mb-2">
                        Username:{" "}
                        <span className="ml-1 font-normal">
                          {targetPointReport?.user.asdc_client_user_name}
                        </span>
                      </p>
                    </div>
                  </div>
                )}
                <h2 className="text-center text-3xl text-primary font-bold">
                  {targetPin}
                </h2>
                <h3 className="text-center text-2xl text-text">
                  {"No: " + selectedPoint?.point_serial}
                </h3>
                <p className="text-center">
                  {
                    selectedPoint?.title[
                      services.find((s: any) => s.id === selectedService)?.name
                    ]
                  }
                </p>
                <p className="text-center">
                  {
                    selectedPoint?.bio[
                      services.find((s: any) => s.id === selectedService)?.name
                    ]
                  }
                </p>
                <p className="text-center w-1/2 mx-auto">
                  {
                    selectedPoint?.description[
                      services.find((s: any) => s.id === selectedService)?.name
                    ]
                  }
                </p>

                {selectedService && (
                  <>
                    {selectedPoint?.point_images[
                      services.find((s: any) => s.id === selectedService)?.name
                    ] &&
                    selectedPoint?.point_images[
                      services.find((s: any) => s.id === selectedService)?.name
                    ] !== undefined ? (
                      <Image
                        alt="point image"
                        src={
                          selectedPoint?.point_images[
                            services.find((s: any) => s.id === selectedService)
                              ?.name
                          ]
                        }
                        className="h-24 mx-auto object-contain"
                        onClick={() => {
                          setCursol([
                            selectedPoint?.point_images[
                              services.find(
                                (s: any) => s.id === selectedService
                              )?.name
                            ],
                          ]);
                        }}
                      />
                    ) : (
                      <div className="text-center text-gray-500">
                        {t("no_point_image")}
                      </div>
                    )}
                  </>
                )}
              </div>

              {targetPointReport?.questions.length > 0 && (
                <div className="text-center p-4 rounded-lg mb-8 mt-12 w-full mx-auto flex flex-col gap-6 items-center justify-between">
                  <h1 className="text-4xl font-bold mx-4">
                    {targetPointReport?.report_title}
                  </h1>
                  <p className="text-2xl text-secondary_text mx-4">
                    {t("operation_plan")}
                  </p>
                  {targetPointReport?.report_type !== "two_ways" &&
                    targetPointReport?.report_type !== "follow_up" && (
                      <p className="text-xl text-secondary_text mx-4">
                        {targetPointReport?.questions[0]?.time +
                          " " +
                          targetPointReport?.questions[0]?.date.split("T")[0]}
                      </p>
                    )}
                  {(targetPointReport?.report_type === "two_ways" ||
                    targetPointReport?.report_type === "follow_up") && (
                    <>
                      <p className="text-xl text-secondary_text mx-4 flex items-center gap-2">
                        <span className="">
                          <span className="font-bold">{t("time_in")}:</span>
                          {`${
                            targetPointReport?.questions?.filter(
                              (q: any) => q?.stage === "Opened"
                            )[0]?.time
                          }`}
                        </span>
                        <span>
                          <span className="font-bold">{t("time_out")}:</span>
                          {`${
                            targetPointReport?.questions?.filter(
                              (q: any) => q?.stage === "Closed"
                            )[0]?.time || "N/A"
                          }`}
                        </span>
                      </p>
                      <p className="text-xl text-secondary_text mx-4 flex items-center gap-2">
                        <span className="">
                          <span className="font-bold">{t("duration")}:</span>
                          {calculateDuration(
                            targetPointReport?.questions?.filter(
                              (q: any) => q?.stage === "Opened"
                            )[0]?.time,
                            targetPointReport?.questions?.filter(
                              (q: any) => q?.stage === "Closed"
                            )[0]?.time
                          )}
                        </span>
                        <span>
                          <span className="font-bold">{t("date")}:</span>

                          {`${
                            targetPointReport?.questions
                              ?.filter((q: any) => q?.stage === "Opened")[0]
                              ?.date?.split("T")[0]
                          }`}
                        </span>
                      </p>
                    </>
                  )}
                </div>
              )}
              {/* Questions */}
              {targetPointReport?.questions.length > 0 &&
                (targetPointReport?.report_type === "two_ways" ||
                  targetPointReport?.report_type === "follow_up") && (
                  <div className="border-2 py-4 px-8 rounded-lg mt-4">
                    <h2 className="text-4xl font-bold">
                      {t("opened_questions")}
                    </h2>
                  </div>
                )}

              {targetPointReport?.questions.length > 0 &&
                targetPointReport?.questions?.map((quest: any, i: number) => {
                  if (
                    (targetPointReport?.report_type === "two_ways" ||
                      targetPointReport?.report_type === "follow_up") &&
                    (quest.stage === "Closed" || quest.stage === "Action")
                  ) {
                    return;
                  }
                  return (
                    <div className="border-2 py-4 px-8 rounded-lg mt-4" key={i}>
                      <h2 className="text-3xl">
                        {quest?.question_title} -{" "}
                        <span className="text-sm capitalize">
                          {/* {quest.question_type === "essay"
                            ? "Essay"
                            : quest.question_type === "AI"
                            ? "Ai"
                            : quest.question_type === "Date"
                            ? "Date"
                            : quest.question_type === "single_choice"
                            ? "Single Choice"
                            : quest.question_type === "multiple_choice"
                            ? "Multiple Choice"
                            : "Positivness Check"} */}
                          {t(quest.question_type)}
                        </span>
                      </h2>
                      {quest.question_type === "essay" ||
                      quest.question_type === "Date" ||
                      quest.question_type === "number" ||
                      quest.question_type === "check_visitor_blackList" ||
                      quest.question_type === "check_staff_blackList" ||
                      quest.question_type === "rating" ||
                      quest.question_type === "AI" ? (
                        <>
                          <p className="border-black border-b border-opacity-30 border-dashed pb-2 mt-6">
                            {quest.question_type === "Date"
                              ? new Date(quest.choices[0].title)
                                  .toString()
                                  .split("GMT")[0]
                              : quest.choices[0].title}
                          </p>
                          <div className="flex gap-4 mt-6 flex-wrap">
                            {quest?.imgs?.map((img: any, i: number) => {
                              if (
                                img.question_picture_url.endsWith(".jpg") ||
                                img.question_picture_url.endsWith(".png") ||
                                img.question_picture_url.endsWith(".jpeg")
                              ) {
                                return (
                                  <Image
                                    className="rounded-md h-[400px] w-fit"
                                    src={img.question_picture_url}
                                    alt={`question image-${i}`}
                                    key={img.question_picture_url}
                                  />
                                );
                              } else {
                                return (
                                  <a
                                    href={API_LINK + img.question_picture_url}
                                    target="_blank"
                                  >
                                    <IoDocumentTextOutline className="text-5xl text-text" />
                                  </a>
                                );
                              }
                            })}
                          </div>
                        </>
                      ) : quest.question_type === "single_choice" ? (
                        <>
                          {/* Choices */}
                          <div className="flex items-start gap-6 mt-3 flex-col">
                            {quest.choices.map((choice: any, i: number) => (
                              <div
                                className="flex-row-reverse flex items-center gap-2 mt-4"
                                key={i}
                              >
                                <label>{choice.title}</label>
                                <input
                                  className={`cursor-default ${
                                    choice.value
                                      ? "disabled:opacity-90"
                                      : "disabled:opacity-30"
                                  } relative mr-1 mt-0.5 h-5 !w-5 appearance-none !border-2 !border-solid !border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:rounded-none dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
                                  type="radio"
                                  checked={choice.value}
                                  disabled
                                />
                              </div>
                            ))}
                          </div>
                          {/* Images */}
                          <div className="mt-8 flex gap-4 flex-wrap">
                            {quest?.imgs?.map((img: any, i: number) => {
                              if (
                                img.question_picture_url.endsWith(".jpg") ||
                                img.question_picture_url.endsWith(".png") ||
                                img.question_picture_url.endsWith(".jpeg")
                              ) {
                                return (
                                  <Image
                                    className="rounded-md h-[400px] w-fit"
                                    src={img.question_picture_url}
                                    alt={`question image-${i}`}
                                    key={img.question_picture_url}
                                  />
                                );
                              } else {
                                return (
                                  <a
                                    href={API_LINK + img.question_picture_url}
                                    target="_blank"
                                  >
                                    <IoDocumentTextOutline className="text-5xl text-text" />
                                  </a>
                                );
                              }
                            })}
                          </div>
                        </>
                      ) : (
                        // If Multiple Choice
                        <>
                          <div className="flex items-start gap-6 mt-3 flex-col">
                            {quest.choices.map((choice: any, i: number) => (
                              <div
                                className="flex-row-reverse flex items-center gap-2 mt-4"
                                key={i}
                              >
                                <label>{choice.title}</label>
                                <input
                                  className={`cursor-default ${
                                    choice.value
                                      ? "disabled:opacity-90"
                                      : "disabled:opacity-30"
                                  } relative mr-1 mt-0.5 h-5 !w-5 appearance-none !border-2 !border-solid !border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:bg-primary dark:checked:after:rounded-none dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
                                  type="checkbox"
                                  checked={choice.value}
                                  disabled
                                />
                              </div>
                            ))}
                          </div>
                          <div className="mt-8 flex gap-4 flex-wrap">
                            {quest?.imgs?.map((img: any, i: number) => {
                              if (
                                img.question_picture_url.endsWith(".jpg") ||
                                img.question_picture_url.endsWith(".png") ||
                                img.question_picture_url.endsWith(".jpeg")
                              ) {
                                return (
                                  <Image
                                    className="rounded-md h-[400px] w-fit"
                                    src={img.question_picture_url}
                                    alt={`question image-${i}`}
                                    key={img.question_picture_url}
                                  />
                                );
                              } else {
                                return (
                                  <a
                                    href={API_LINK + img.question_picture_url}
                                    target="_blank"
                                  >
                                    <IoDocumentTextOutline className="text-5xl text-text" />
                                  </a>
                                );
                              }
                            })}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              {(targetPointReport?.report_type === "two_ways" ||
                targetPointReport?.report_type === "follow_up") &&
                targetPointReport?.questions.length > 0 &&
                targetPointReport?.questions.filter(
                  (q: any) => q.stage === "Action"
                ).length > 0 && (
                  <div className="border-2 py-4 px-8 rounded-lg mt-4">
                    <h2 className="text-4xl font-bold">
                      {t("action_questions")}
                    </h2>
                  </div>
                )}
              {(targetPointReport?.report_type === "two_ways" ||
                targetPointReport?.report_type === "follow_up") &&
                targetPointReport?.questions.length > 0 &&
                targetPointReport?.questions.filter(
                  (q: any) => q.stage === "Action"
                ).length > 0 && (
                  <>
                    {targetPointReport?.questions
                      .filter((q: any) => q.stage === "Action")
                      .map((quest: any, i: number) => (
                        <div
                          className="border-2 py-4 px-8 rounded-lg mt-4"
                          key={i}
                        >
                          <h2 className="text-3xl">
                            {quest?.question_title} -{" "}
                            <span className="text-sm capitalize">
                              {/* {quest.question_type === "essay"
                                ? "Essay"
                                : quest.question_type === "AI"
                                ? "Ai"
                                : quest.question_type === "Date"
                                ? "Date"
                                : quest.question_type === "single_choice"
                                ? "Single Choice"
                                : "Multiple Choice"} */}
                              {t(quest.question_type)}
                            </span>
                          </h2>
                          {quest.question_type === "essay" ||
                          quest.question_type === "Date" ||
                          quest.question_type === "number" ||
                          quest.question_type === "check_visitor_blackList" ||
                          quest.question_type === "check_staff_blackList" ||
                          quest.question_type === "rating" ||
                          quest.question_type === "AI" ? (
                            <>
                              <p className="border-black border-b border-opacity-30 border-dashed pb-2 mt-6">
                                {quest.question_type === "Date"
                                  ? new Date(quest.choices[0].title)
                                      .toString()
                                      .split("GMT")[0]
                                  : quest.choices[0].title}
                              </p>
                              <div className="flex gap-4 mt-6 flex-wrap">
                                {quest?.imgs?.map((img: any, i: number) => {
                                  if (
                                    img.question_picture_url.endsWith(".jpg") ||
                                    img.question_picture_url.endsWith(".png") ||
                                    img.question_picture_url.endsWith(".jpeg")
                                  ) {
                                    return (
                                      <Image
                                        className="rounded-md h-[400px] w-fit"
                                        src={img.question_picture_url}
                                        alt={`question image-${i}`}
                                        key={img.question_picture_url}
                                      />
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={
                                          API_LINK + img.question_picture_url
                                        }
                                        target="_blank"
                                      >
                                        <IoDocumentTextOutline className="text-5xl text-text" />
                                      </a>
                                    );
                                  }
                                })}
                              </div>
                            </>
                          ) : quest.question_type === "single_choice" ? (
                            <>
                              {/* Choices */}
                              <div className="flex items-start gap-6 mt-3 flex-col">
                                {quest.choices.map((choice: any, i: number) => (
                                  <div
                                    className="flex-row-reverse flex items-center gap-2 mt-4"
                                    key={i}
                                  >
                                    <label>{choice.title}</label>
                                    <input
                                      className={`cursor-default ${
                                        choice.value
                                          ? "disabled:opacity-90"
                                          : "disabled:opacity-30"
                                      } relative mr-1 mt-0.5 h-5 !w-5 appearance-none !border-2 !border-solid !border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:rounded-none dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
                                      type="radio"
                                      checked={choice.value}
                                      disabled
                                    />
                                  </div>
                                ))}
                              </div>
                              {/* Images */}
                              <div className="mt-8 flex gap-4 flex-wrap">
                                {quest?.imgs?.map((img: any, i: number) => {
                                  if (
                                    img.question_picture_url.endsWith(".jpg") ||
                                    img.question_picture_url.endsWith(".png") ||
                                    img.question_picture_url.endsWith(".jpeg")
                                  ) {
                                    return (
                                      <Image
                                        className="rounded-md h-[400px] w-fit"
                                        src={img.question_picture_url}
                                        alt={`question image-${i}`}
                                        key={img.question_picture_url}
                                      />
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={
                                          API_LINK + img.question_picture_url
                                        }
                                        target="_blank"
                                      >
                                        <IoDocumentTextOutline className="text-5xl text-text" />
                                      </a>
                                    );
                                  }
                                })}
                              </div>
                            </>
                          ) : (
                            // If Multiple Choice
                            <>
                              <div className="flex items-start gap-6 mt-3 flex-col">
                                {quest.choices.map((choice: any, i: number) => (
                                  <div
                                    className="flex-row-reverse flex items-center gap-2 mt-4"
                                    key={i}
                                  >
                                    <label>{choice.title}</label>
                                    <input
                                      className={`cursor-default ${
                                        choice.value
                                          ? "disabled:opacity-90"
                                          : "disabled:opacity-30"
                                      } relative mr-1 mt-0.5 h-5 !w-5 appearance-none !border-2 !border-solid !border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:rounded-none dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
                                      type="checkbox"
                                      checked={choice.value}
                                      disabled
                                    />
                                  </div>
                                ))}
                              </div>
                              <div className="mt-8 flex gap-4 flex-wrap">
                                {quest?.imgs?.map((img: any, i: number) => {
                                  if (
                                    img.question_picture_url.endsWith(".jpg") ||
                                    img.question_picture_url.endsWith(".png") ||
                                    img.question_picture_url.endsWith(".jpeg")
                                  ) {
                                    return (
                                      <Image
                                        className="rounded-md h-[400px] w-fit"
                                        src={img.question_picture_url}
                                        alt={`question image-${i}`}
                                        key={img.question_picture_url}
                                      />
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={
                                          API_LINK + img.question_picture_url
                                        }
                                        target="_blank"
                                      >
                                        <IoDocumentTextOutline className="text-5xl text-text" />
                                      </a>
                                    );
                                  }
                                })}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                  </>
                )}
              {(targetPointReport?.report_type === "two_ways" ||
                targetPointReport?.report_type === "follow_up") &&
                targetPointReport?.questions.length > 0 &&
                targetPointReport?.questions.filter(
                  (q: any) => q.stage === "Closed"
                ).length > 0 && (
                  <div className="border-2 py-4 px-8 rounded-lg mt-4">
                    <h2 className="text-4xl font-bold">
                      {t("closed_questions")}
                    </h2>
                  </div>
                )}
              {(targetPointReport?.report_type === "two_ways" ||
                targetPointReport?.report_type === "follow_up") &&
                targetPointReport?.questions.length > 0 &&
                targetPointReport?.questions.filter(
                  (q: any) => q.stage === "Closed"
                ).length > 0 && (
                  <>
                    {targetPointReport?.questions
                      .filter((q: any) => q.stage === "Closed")
                      .map((quest: any, i: number) => (
                        <div
                          className="border-2 py-4 px-8 rounded-lg mt-4"
                          key={i}
                        >
                          <h2 className="text-3xl">
                            {quest?.question_title} -{" "}
                            <span className="text-sm capitalize">
                              {/* {quest.question_type === "essay"
                                ? "Essay"
                                : quest.question_type === "AI"
                                ? "Ai"
                                : quest.question_type === "Date"
                                ? "Date"
                                : quest.question_type === "single_choice"
                                ? "Single Choice"
                                : "Multiple Choice"} */}
                              {t(quest.question_type)}
                            </span>
                          </h2>
                          {quest.question_type === "essay" ||
                          quest.question_type === "Date" ||
                          quest.question_type === "number" ||
                          quest.question_type === "check_visitor_blackList" ||
                          quest.question_type === "check_staff_blackList" ||
                          quest.question_type === "rating" ||
                          quest.question_type === "AI" ? (
                            <>
                              <p className="border-black border-b border-opacity-30 border-dashed pb-2 mt-6">
                                {quest.question_type === "Date"
                                  ? new Date(quest.choices[0].title)
                                      .toString()
                                      .split("GMT")[0]
                                  : quest.choices[0].title}
                              </p>
                              <div className="flex gap-4 mt-6 flex-wrap">
                                {quest?.imgs?.map((img: any, i: number) => {
                                  if (
                                    img.question_picture_url.endsWith(".jpg") ||
                                    img.question_picture_url.endsWith(".png") ||
                                    img.question_picture_url.endsWith(".jpeg")
                                  ) {
                                    return (
                                      <Image
                                        className="rounded-md h-[400px] w-fit"
                                        src={img.question_picture_url}
                                        alt={`question image-${i}`}
                                        key={img.question_picture_url}
                                      />
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={
                                          API_LINK + img.question_picture_url
                                        }
                                        target="_blank"
                                      >
                                        <IoDocumentTextOutline className="text-5xl text-text" />
                                      </a>
                                    );
                                  }
                                })}
                              </div>
                            </>
                          ) : quest.question_type === "single_choice" ? (
                            <>
                              {/* Choices */}
                              <div className="flex items-start gap-6 mt-3 flex-col">
                                {quest.choices.map((choice: any, i: number) => (
                                  <div
                                    className="flex-row-reverse flex items-center gap-2 mt-4"
                                    key={i}
                                  >
                                    <label>{choice.title}</label>
                                    <input
                                      className={`cursor-default ${
                                        choice.value
                                          ? "disabled:opacity-90"
                                          : "disabled:opacity-30"
                                      } relative mr-1 mt-0.5 h-5 !w-5 appearance-none !border-2 !border-solid !border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:rounded-none dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
                                      type="radio"
                                      checked={choice.value}
                                      disabled
                                    />
                                  </div>
                                ))}
                              </div>
                              {/* Images */}
                              <div className="mt-8 flex gap-4 flex-wrap">
                                {quest?.imgs?.map((img: any, i: number) => {
                                  if (
                                    img.question_picture_url.endsWith(".jpg") ||
                                    img.question_picture_url.endsWith(".png") ||
                                    img.question_picture_url.endsWith(".jpeg")
                                  ) {
                                    return (
                                      <Image
                                        className="rounded-md h-[400px] w-fit"
                                        src={img.question_picture_url}
                                        alt={`question image-${i}`}
                                        key={img.question_picture_url}
                                      />
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={
                                          API_LINK + img.question_picture_url
                                        }
                                        target="_blank"
                                      >
                                        <IoDocumentTextOutline className="text-5xl text-text" />
                                      </a>
                                    );
                                  }
                                })}
                              </div>
                            </>
                          ) : (
                            // If Multiple Choice
                            <>
                              <div className="flex items-start gap-6 mt-3 flex-col">
                                {quest.choices.map((choice: any, i: number) => (
                                  <div
                                    className="flex-row-reverse flex items-center gap-2 mt-4"
                                    key={i}
                                  >
                                    <label>{choice.title}</label>
                                    <input
                                      className={`cursor-default ${
                                        choice.value
                                          ? "disabled:opacity-90"
                                          : "disabled:opacity-30"
                                      } relative mr-1 mt-0.5 h-5 !w-5 appearance-none !border-2 !border-solid !border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:rounded-none dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
                                      type="checkbox"
                                      checked={choice.value}
                                      disabled
                                    />
                                  </div>
                                ))}
                              </div>
                              <div className="mt-8 flex gap-4 flex-wrap">
                                {quest?.imgs?.map((img: any, i: number) => {
                                  if (
                                    img.question_picture_url.endsWith(".jpg") ||
                                    img.question_picture_url.endsWith(".png") ||
                                    img.question_picture_url.endsWith(".jpeg")
                                  ) {
                                    return (
                                      <Image
                                        className="rounded-md h-[400px] w-fit"
                                        src={img.question_picture_url}
                                        alt={`question image-${i}`}
                                        key={img.question_picture_url}
                                      />
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={
                                          API_LINK + img.question_picture_url
                                        }
                                        target="_blank"
                                      >
                                        <IoDocumentTextOutline className="text-5xl text-text" />
                                      </a>
                                    );
                                  }
                                })}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                  </>
                )}
              {targetPointReport?.questions.length === 0 &&
                targetPointReport?.report_title &&
                selectedService && (
                  <div className="text-center mt-8 flex flex-col gap-4">
                    <h1 className="text-xl font-bold">
                      {targetPointReport?.report_title}
                    </h1>
                    <h1 className="text-lg text-secondary_text">
                      {t("no_answers_available")}
                    </h1>
                  </div>
                )}
              {!targetPointReport?.report_title && selectedService && (
                <div className="text-center mt-8">
                  <h1 className="text-lg text-secondary_text">
                    {t("no_reports_available")}
                  </h1>
                </div>
              )}
              {!selectedService && (
                <div className="text-center mt-8">
                  <h1 className="text-lg text-secondary_text">
                    {t("select_service_first")}
                  </h1>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* filter options */}
        <div
          className={`fixed top-0 bg-white h-full duration-300 z-[99999] p-8 !pt-44 flex flex-col gap-4 shadow-2xl ${
            filter.dates ? "end-0 w-[25vw]" : "-end-96 w-0"
          } toggleFilter`}
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-3xl font-bold relative mb-10">
            {t("filter_options")}
            <IoClose
              className="text-3xl cursor-pointer absolute top-1 end-5"
              onClick={() => setFilter({ ...filter, dates: false })}
            />
          </h2>
          <div className="flex flex-col gap-1">
            <label className="text-text text-lg">{t("from")}</label>
            <input
              type="datetime-local"
              className="!w-40"
              onChange={(e) => {
                // console.log(e.target.value, "date");
                setResetLayout(false);
                setDate({ ...date, startDate: e.target.value });
              }}
              value={date.startDate}
              key={"Date :" + selectedPoint?.point_qrcode + " " + targetPin}
              min={getCurrentDateTimeISO()}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-text text-lg">{t("to")}</label>
            <input
              type="datetime-local"
              className="!w-40"
              onChange={(e) => {
                // console.log(e.target.value, "date");
                setResetLayout(false);
                setDate({ ...date, endDate: e.target.value });
              }}
              value={date.endDate}
              key={"Date :" + selectedPoint?.point_qrcode + " " + targetPin}
              min={date.startDate}
            />
          </div>
          {/* {Object.keys(filterOptions).filter((key) => filterOptions[key] !== null)
          .length > 0 && (
          <div
            className="flex flex-col gap-1 text-blue-500 cursor-pointer"
            onClick={() => setFilterOptions(defaultFilterOptions)}
          >
            {t("reset")}
          </div>
        )} */}
        </div>

        {/* Instructions icon */}
        <div
          className={`absolute bottom-4 lg:bottom-12 2xl:bottom-16 w-[2rem] h-[2rem] md:w-[2.4rem] md:h-[2.4rem] lg:w-[2.7rem] lg:h-[2.7rem] xl:w-[3rem] xl:h-[3rem] 2xl:w-[3.2rem] 2xl:h-[3.2rem] flex flex-col justify-center items-end gap-3 ${
            i18next.language === "ar" ? "right-1" : "left-1"
          }`}
        >
          <span
            className="h-10 w-10 grid place-content-center rounded-full border-gray-500 border-solid border-4 text-gray-500 text-2xl font-bold hover:text-gray-700 hover:border-gray-700 hover:skew-x-6 hover:scale-110 duration-200 cursor-pointer"
            onClick={() => setToggleInstructions(true)}
          >
            ?
          </span>
        </div>
      </div>
      {/* Instructions */}
      {toggleInstructions && (
        <div
          className={`fixed top-0 left-0 w-full h-full z-[99999] bg-black bg-opacity-50 flex justify-center items-center ${
            toggleInstructions ? "flex" : "hidden"
          }`}
          onClick={() => setToggleInstructions(false)}
        >
          <div
            className={`bg-white rounded-lg p-8 flex flex-col gap-8 ${
              i18next.language === "ar" ? "rtl" : ""
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-center text-lg font-bold">
              {t("instructions")}
            </h2>
            <ul className="list-disc list-inside flex flex-col gap-4">
              <li className="flex justify-between items-center gap-20">
                {t("enter_the_floor")} :
                <div className="flex items-center gap-1">
                  {t("left_click_on_the_floor")}
                  <img src={leftClick} alt="mouse" className="w-12" />
                </div>
              </li>
              <li className="flex justify-between items-center gap-20">
                {t("rotate_the_layout")} :
                <div className="flex items-center gap-1">
                  {t("left_click_and_drag")}
                  <img src={leftClick} alt="mouse" className="w-12" />
                </div>
              </li>
              <li className="flex justify-between items-center gap-20">
                {t("move_the_layout")} :
                <div className="flex items-center gap-1">
                  {t("right_click_and_drag")}
                  <img src={rightClick} alt="mouse" className="w-12" />
                </div>
              </li>
              <li className="flex justify-between items-center gap-20">
                {t("zoom_in_out")} :
                <div className="flex items-center gap-1">
                  {t("scroll_up_down")}
                  <img
                    src={zoom}
                    alt="mouse"
                    className={`w-10 ${
                      i18next.language === "ar" ? "ml-1" : "mr-1"
                    }`}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
      {/* Cursol */}
      {cursol.length > 0 && (
        <div
          className="fixed top-0 left-0 z-[100] w-full h-full bg-black bg-opacity-50 flex justify-center items-center"
          onClick={() => setCursol([])}
        >
          <div
            className="bg-white p-4 rounded-lg max-w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end -mt-3 mb-4">
              <button
                className="text-5xl font-bold text-red-500"
                onClick={() => setCursol([])}
              >
                &times;
              </button>
            </div>
            <div className="flex gap-10 overflow-x-auto">
              {cursol.map((pic: any) => {
                if (
                  pic.endsWith(".jpg") ||
                  pic.endsWith(".png") ||
                  pic.endsWith(".jpeg")
                ) {
                  return (
                    <Image
                      className="h-[550px] w-fit object-contain"
                      src={pic}
                      alt="Question Image"
                      key={pic}
                    />
                  );
                  // } else if (pic.question_picture_url.endsWith(".pdf")) {
                  //   return (
                  //     <a href={API_LINK + pic.question_picture_url} target="_blank">
                  //     </a>
                  //   )
                } else {
                  return (
                    <a
                      href={API_LINK + pic}
                      target="_blank"
                      className="h-[550px] min-w-[250px] bg-secondary hover:opacity-75 duration-200 grid place-content-center"
                    >
                      <IoDocumentTextOutline className="text-5xl text-text" />
                    </a>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
